/* eslint-disable @next/next/no-img-element */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import cn from 'classnames'
import { FC, ComponentPropsWithoutRef, useState, memo, forwardRef } from 'react'

import styles from './Image.module.scss'

import Spinner from '~elements/Spinner'

interface ImageProps extends ComponentPropsWithoutRef<'div'> {
  alt: string
  renderAlt?: (alt: string) => JSX.Element
  src?: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xm' | 'fit' | 'double'
  round?: boolean
  highlight?: boolean
  loading?: boolean
  detailed?: boolean
  asset?: boolean
  bordered?: boolean
}

const defaultRenderAlt = (alt = '') => {
  return <div className={styles.alt}>{alt[0]?.toUpperCase()}</div>
}

const Image: FC<React.PropsWithChildren<ImageProps>> = forwardRef<HTMLDivElement, ImageProps>(
  (
    {
      alt,
      renderAlt = defaultRenderAlt,
      src,
      size = 'md',
      detailed,
      round,
      highlight,
      loading,
      className,
      asset,
      bordered,
      ...props
    },
    ref
  ) => {
    const [error, setError] = useState(false)

    return (
      <span
        ref={ref}
        title={alt}
        className={cn(
          styles.root,
          { [styles.asset]: asset },
          { [styles.detailed]: detailed },
          styles[size],
          { [styles.round]: round, [styles.highlight]: highlight },
          className
        )}
        onError={() => setError(true)}
        {...props}
      >
        {src && !error ? (
          <img src={src} alt={alt} className={cn(styles.image, { [styles.bordered]: bordered })} />
        ) : (
          renderAlt(alt)
        )}
        {loading && <Spinner className={styles.spinner} size="xs" />}
      </span>
    )
  }
)

export type { ImageProps }
export default memo(Image)
